// Global
import { tv } from 'tailwind-variants';

export const tailwindVariants = tv({
  slots: {
    // Here we are added product-information class for the splide slider.
    base: ['product-information-wrapper', 'bg-components-article-hero-color-bg', 'component'],
    totalWrapper: [
      'flex',
      'flex-col-reverse',
      'py-themes-general-surface-spacing-small-padding-y',
      'px-themes-general-surface-spacing-small-padding-x',
      'md:py-themes-general-surface-spacing-large-padding-y',
      'md:px-themes-general-surface-spacing-large-padding-x',
      'md:flex-row',
      'lg:items-center',
      'gap-components-article-hero-spacing-small-content-margin-top',
      'md:gap-spacing-spacing-8',
    ],
    labelWrapper: [
      'flex',
      'flex-wrap',
      'mb-components-article-hero-spacing-small-label-share-margin-bottom',
      'md:mb-components-article-hero-spacing-large-label-share-margin-bottom',
      'gap-spacing-spacing-3',
    ],
    productInformationLeftWrapper: ['flex-1'],
    shareWrapper: ['ml-auto', 'order-2'],
    heroIngredientWrapper: [
      'component-content',
      'justify-center',
      'flex',
      'flex-col',
      'h-full',
      'flex-1',
    ],
    heroIngredientTitle: [
      'article-title',
      'font-header-small-large',
      'leading-header-small-large',
      'text-header-small-large',
      'text-components-article-hero-color-headline',
      'relative',
      'mb-components-article-hero-spacing-small-title-margin-bottom',
      'md:mb-components-article-hero-spacing-large-title-margin-bottom',
      'md:font-header-large-large',
      'md:leading-header-large-large',
      'md:text-header-large-large',
    ],
    heroIngredientDescriptionWrapper: [
      'flex',
      'flex-col',
      'field-heroIngredientDescription',
      'mb-components-article-hero-spacing-small-body-margin-bottom',
      'md:mb-components-article-hero-spacing-large-body-margin-bottom',
    ],
    heroIngredientDescription: [
      'article-description',
      'relative',
      'font-bodySans-medium',
      'text-bodySans-medium',
      'leading-bodySans-medium',
      'md:font-bodySans-large',
      'md:text-bodySans-large',
      'md:leading-bodySans-large',
      'text-components-article-hero-color-body',
    ],
    heroIngredientDefinition: [
      'text-bodySans-large-semibold',
      'leading-bodySans-large-semibold',
      'font-bodySans-large-semibold',
      'md:text-bodySans-medium-semibold',
      'md:leading-bodySans-medium-semibold',
      'md:font-bodySans-medium-semibold',
      'text-components-article-hero-color-detail-text',
      'mb-components-article-hero-spacing-small-details-margin-bottom',
      'md:mb-components-article-hero-spacing-large-details-margin-bottom',
    ],
  },
  variants: {
    alignment: {
      Center: {
        heroIngredientWrapper: ['items-center'],
        heroIngredientTitle: ['text-center'],
        heroIngredientDescription: ['text-center'],
      },
      Left: {},
    },
  },
});
